import { useColorModeValue } from '@chakra-ui/react'
import { CSSProperties } from 'react'

// Recharts takes raw CSS colors, not Chakra tokens, so the chart chrome
// (grid, axis ticks, tooltip, hover cursor) resolves its color mode here.
// Values mirror Chakra's gray scale: gray.200/700 grid, gray.600/400 ticks,
// white/gray.700 tooltip.
export const useChartPalette = () => {
  const grid = useColorModeValue('#E2E8F0', '#4A5568')
  const tick = useColorModeValue('#4A5568', '#A0AEC0')
  const cursor = useColorModeValue('rgba(0, 0, 0, 0.05)', 'rgba(255, 255, 255, 0.08)')
  const tooltipBg = useColorModeValue('#FFFFFF', '#2D3748')
  const tooltipText = useColorModeValue('#1A202C', '#F7FAFC')

  const tooltipStyle: CSSProperties = {
    backgroundColor: tooltipBg,
    borderColor: grid,
    color: tooltipText,
    borderRadius: 6,
  }
  const tooltipProps = {
    contentStyle: tooltipStyle,
    itemStyle: { color: tooltipText },
    labelStyle: { color: tooltipText },
  }

  return { grid, tick, cursor, tooltipProps }
}
